module.exports = __webpack_public_path__ + "static/media/beijing.3c136e9f.png";